import { UtilService } from 'src/app/core/services/util/util.service';
import { Injectable, OnDestroy, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, map, take } from 'rxjs/operators';
import { AppGlobalsModule as _globals } from '../app-globals.module';
import { BehaviorSubject, Observable, AsyncSubject, Subscription, of, firstValueFrom, Subject } from 'rxjs';
import { ContentAreaService } from '../content-area/content-area.service';
import { YeshivaEnums } from 'src/serverTypes/yeshivaTypesEnums';
import { AngularApp, YeshivaModels } from 'src/serverTypes/yeshivaTypesDeclare';
import { NavigationEnd, Router, Event } from '@angular/router';
import { ErrorsService } from '../core/errors/errors-service/errors.service';
import { AngularPages, UrlAddressService } from '../core/services/url-address/url-address.service';
import { I18nService } from '../core/services/i18n/i18n.service';
@Injectable()
// {
//     providedIn: 'root'
// }
export class CategoryService implements OnDestroy {
    private _router = inject(Router);
    private _http = inject(HttpClient);
    private _contentAreaService = inject(ContentAreaService);
    private errorService = inject(ErrorsService);
    private _utils = inject(UtilService);
    private urlAdress = inject(UrlAddressService);
    private _i18n = inject(I18nService);
    private fromArea = inject<string>('fromArea' as any, { optional: true })!;

    subscribes: Subscription[] = [];
    constructor() {
        this.categoryUrl = this._contentAreaService.getContentApiPath('contentscategory');

        if (this._contentAreaService.apiBase() || this.fromArea) {
            this.categoryTreeUrl = this._contentAreaService.getContentApiPath(
                'contentscategory',
                this._contentAreaService.apiBase() ? this._contentAreaService.apiBase() : this.fromArea,
            );
            this.loadTreeAndDictonery();
        }
        this._categoryWrapper$ = new Subject<AngularApp.API.CategoryWrapper | null>();
        this.catName = this._contentAreaService.areaTexts?.title;
        this._isCategoryTreeMenuOpen$ = new BehaviorSubject<boolean>(false);
        this.subscribes.push(
            this._router.events.pipe(filter((e: Event | NavigationEnd): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(() => {
                if (this._isCategoryTreeMenuOpen) {
                    this.setIsCategoryTreeMenuOpen(false);
                }
            }),
        );
        this.subscribes.push(
            this.getIsCategoryTreeMenuOpen().subscribe((isCategoryTreeMenuOpen: boolean) => {
                this._isCategoryTreeMenuOpen = isCategoryTreeMenuOpen;
            }),
        );
    }

    private _isCategoryTreeMenuOpen = false;
    public _isCategoryTreeMenuOpen$: BehaviorSubject<boolean>;
    public getIsCategoryTreeMenuOpen(): Observable<boolean> {
        return this._isCategoryTreeMenuOpen$.asObservable();
    }
    public setIsCategoryTreeMenuOpen(isCategoryTreeMenuOpen: boolean): void {
        this._isCategoryTreeMenuOpen$.next(isCategoryTreeMenuOpen);
    }
    public catName: string;
    public AngularPages = AngularPages;
    getMainCategory(category: YeshivaModels.BE.Category): CategoryNode | null {
        let mainCategoryParent: CategoryNode | null = null;

        try {
            // find the main category in the parents list (don't check only the second - maybe implementation would be changed)
            for (let i = category.Parents.length - 1; i >= 0 && mainCategoryParent == null; i--) {
                let parentId = parseInt(category.Parents[i].toString(), 10);
                if (this._getIsMainCategory(parentId)) {
                    mainCategoryParent = this.getCategoryfromDictionery(parentId);
                }
            }
        } catch (error) {}

        return mainCategoryParent;
    }

    /**
     * The main category (a child of the tree root) above a category, from the tree dictionary
     * alone - the category itself when it is a main one. Needs nothing but the id, so the
     * breadcrumb no longer waits on the category wrapper api (the heavy `getcontent=true` read)
     * that used to feed getMainCategory its Parents list. null when the id is not in the tree.
     */
    getMainCategoryById(id: number): CategoryNode | null {
        try {
            let node: CategoryNode | undefined = this.getCategoryfromDictionery(id);
            while (node) {
                if (this._getIsMainCategory(node.id)) {
                    return node;
                }
                node = node.parent;
            }
        } catch (error) {}
        return null;
    }

    private categoriesTree: any = {};
    private categoriesSeriesTree: any = {};
    private categoriesFullTree: YeshivaModels.BE.CategoryTree = {} as YeshivaModels.BE.CategoryTree;
    private categoriesSeriesFullTree: YeshivaModels.BE.CategoryTree = {} as YeshivaModels.BE.CategoryTree;
    private categoriesHash: any = {};
    private categoriesSeriesHash: any = {};
    readonly DEFAULT_SPECIAL_CATEGORY: number = 2232;
    // use this AsyncSubject to be notified when the tree and dictionary are available to be used
    private categoriesDataLoadedSubject: AsyncSubject<boolean> = new AsyncSubject();
    private categoriesSeriesDataLoadedSubject: AsyncSubject<boolean> = new AsyncSubject();
    private categoriesSeriesLoadPromise: Promise<boolean> | null = null;

    private categoryUrl;
    private categoryTreeUrl;
    private _categoryWrapper$: Subject<AngularApp.API.CategoryWrapper | null>;
    private _setCategoryWrapper$(categoryWrapper: AngularApp.API.CategoryWrapper): void {
        this._categoryWrapper$.next(categoryWrapper);
    }
    public getCategoryWrapper$(): Observable<AngularApp.API.CategoryWrapper | null> {
        return this._categoryWrapper$.asObservable();
    }

    public updateCategoryWrapperByCatId(catId: number, getContent: boolean = true): void {
        // When the routing contain a string for some reason the catId is NaN and can't be fetched
        if (isNaN(catId)) {
            this.errorService.navigateToNotFound();
            return;
        }

        this.subscribes.push(
            this._getCategoryWrapperObserveable(catId, getContent)
                .pipe(take(1))
                .subscribe({
                    next: (categoryWrapper: AngularApp.API.CategoryWrapper) => {
                        this._setCategoryWrapper$(categoryWrapper);
                    },
                    error: (error) => {
                        void this.errorService.handleHttpError(error);
                    },
                }),
        );
    }

    private _getCategoryWrapperObserveable(catId: number, getContent: boolean = false) {
        return this._http.get<AngularApp.API.CategoryWrapper>(this.categoryTreeUrl + `/wrapper?cat=${catId}&getcontent=${getContent}`);
    }

    getCategoryWrapper(id: number, getContent: boolean = true): Promise<AngularApp.API.CategoryWrapper> {
        return firstValueFrom(this._getCategoryWrapperObserveable(id, getContent));
    }

    getCategory(id: number, getContent: boolean = true): Promise<YeshivaModels.BE.Category> {
        return this.getCategoryWrapper(id, getContent)
            .then((category) => this.updateCategoryFromDictionery(category.Entity))
            .catch((e) => {
                this.errorService.log(e);

                // Since the category is not found, we need to return something but not observable...
                return null;
            });
    }

    getSeriesCategory(id: number, getContent: boolean = true): Promise<YeshivaModels.BE.Category> {
        return this.getCategoryWrapper(id, getContent)
            .then((category) => this.updateSeriesCategoryFromDictionery(category.Entity))
            .catch((e) => {
                this.errorService.log(e);

                // Since the category is not found, we need to return something but not observable...
                return null;
            });
    }
    /** the tree response as one parsed+fixed root - shared by the area load and the per-language fetch */
    private _parseTreeResponse(treeString: any): any {
        let json;
        if (treeString.replace) {
            json = JSON.parse(treeString.replace(/@/g, '').replace(/node":/g, 'children":'));
        } else {
            json = treeString;
        }
        if (json.tree) {
            json = json.tree;
        }
        // TODO - check if needed  - maybe can be remove now
        this.fixTreeJsonValues([json]);
        return json;
    }

    private getTree(getSeries: boolean = false): Promise<any> {
        //TODO - use subject to get tree only one time
        let isSeriesStr = this.urlAdress.activeAngularPage === this.AngularPages.Series || getSeries ? '?seriesOnly=true' : '';
        return this._http
            .get<string>(this.categoryTreeUrl + '/tree' + isSeriesStr)
            .pipe(
                map((treeString) => {
                    const json = this._parseTreeResponse(treeString);

                    // save the tree

                    if (this.urlAdress.activeAngularPage === this.AngularPages.Series || getSeries) {
                        this.categoriesSeriesTree = json;
                        this.categoriesSeriesFullTree = this.categoriesSeriesTree;
                    } else {
                        this.categoriesTree = json;
                        this.categoriesFullTree = this.categoriesTree;
                    }
                    if (this._contentAreaService.area === YeshivaEnums.AngularApp.API.enums.Area.midrash) {
                        if (this.urlAdress.activeAngularPage === this.AngularPages.Series || getSeries) {
                            this.categoriesSeriesTree = this.categoriesSeriesTree.children.find((category: CategoryNode) => category.id === 3);
                        } else {
                            this.categoriesTree = this.categoriesTree.children.find((category: CategoryNode) => category.id === 3);
                        }
                    }
                    if (this.urlAdress.activeAngularPage === this.AngularPages.Series || getSeries) {
                        return this.categoriesSeriesTree;
                    } else {
                        return this.categoriesTree;
                    }
                }),
            )
            .toPromise();
    }

    fixTreeJsonValues(nodes: any[]): void {
        for (let node of nodes) {
            node.id = parseInt(node.id, 10);
            if (node.children) {
                // if children isn't an array - create array with this node children
                if (node.children.id) {
                    node.children = [node.children];
                }

                //sort by priority (lower priority is better)
                node.children.sort((a: CategoryNode, b: CategoryNode): number => {
                    if (a.priority < b.priority) {
                        return -1;
                    }
                    if (a.priority === b.priority) {
                        return 0;
                    }

                    return 1;
                });

                //continue
                this.fixTreeJsonValues(node.children);
            }
        }
    }

    createCategoriesDictonary() {
        // go over the tree and add each node to the dictionery
        // add also the parent if not in the tree and connect the son and the parent
        this.categoriesHash = {};
        this.addNodeToDictonery(this.categoriesFullTree);
        return this.categoriesHash;
    }
    createSeriesCategoriesDictonary() {
        // go over the tree and add each node to the dictionery
        // add also the parent if not in the tree and connect the son and the parent
        this.categoriesSeriesHash = {};
        this.addSeriesNodeToDictonery(this.categoriesSeriesFullTree);
        return this.categoriesSeriesHash;
    }
    addNodeToDictonery(treeNode: YeshivaModels.BE.CategoryTree): void {
        if (treeNode != null) {
            if (this.categoriesHash[treeNode.id] == null) {
                this.categoriesHash[treeNode.id] = treeNode;
            }
            if (treeNode?.children) {
                for (let child of treeNode.children) {
                    this.addNodeToDictonery(child);
                    this.categoriesHash[child.id].parent = treeNode;
                }
            }
        }
    }
    addSeriesNodeToDictonery(treeNode: YeshivaModels.BE.CategoryTree): void {
        if (treeNode != null) {
            if (this.categoriesSeriesHash[treeNode.id] == null) {
                this.categoriesSeriesHash[treeNode.id] = treeNode;
            }
            for (let child of treeNode.children) {
                this.addSeriesNodeToDictonery(child);
                this.categoriesSeriesHash[child.id].parent = treeNode;
            }
        }
    }

    public updateCategoryFromDictionery(category: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.subscribes.push(
                this.categoriesDataLoadedSubject.subscribe((loaded) => {
                    // check if the category is in the dictionary
                    // bogrim categories for example aren't in the tree
                    if (loaded && this.getCategoryfromDictionery(category.Id) != null) {
                        category.parent = this.getCategoryParent(category.Id);
                        category.children = this.getCategoryChildren(category.Id);
                    }
                    //a failed tree load (loaded=false) still answers - the category itself is
                    //known, only its tree links are not; a caller must never hang on the tree
                    resolve(category);
                }),
            );
        });
    }

    public updateSeriesCategoryFromDictionery(category: any): Promise<any> {
        return this.loadSeriesTreeAndDictonery().then((loaded) => {
            if (loaded && this.getSeriesCategoryfromDictionery(category.Id) != null) {
                // bogrim categories for example aren't in the tree
                category.parent = this.getSeriesCategoryParent(category.Id);
                category.children = this.getSeriesCategoryChildren(category.Id);
            }
            return category;
        });
    }
    getCategoriesTree(menuTree: boolean = false): Promise<any> {
        return this.categoriesDataLoadedSubject
            .asObservable()
            .toPromise()
            .then((loaded) => {
                if (loaded) {
                    if (menuTree && this._contentAreaService.area === YeshivaEnums.AngularApp.API.enums.Area.midrash) {
                        return this.categoriesTree;
                    } else {
                        return this.categoriesFullTree;
                    }
                } else {
                    // problem to get the tree
                    return null;
                }
            });
    }
    /** the full trees fetched with an explicit ?lang=, memoized per language */
    private _treesForLang = new Map<YeshivaEnums.YeshivaModels.Logic.Globalization.Lang, Promise<any>>();

    /**
     * The nihul's per-language category tree: the same public tree api with an explicit
     * ?lang= override (LanguageForPage honors it), so an en list/form on the hebrew app gets
     * the ENGLISH Hide=0 tree - per-language hide flags and names differ, and a category
     * visible only in english was unpickable on an english shiur (2026-08-09). The app's own
     * language returns the shared area load; the override fetch is memoized apart and NEVER
     * written into the shared tree/dictionary state - the edit overlay shares this service
     * instance with the public page behind it.
     */
    getCategoriesTreeForLang(lang: YeshivaEnums.YeshivaModels.Logic.Globalization.Lang): Promise<any> {
        if (lang === this._i18n.getLangDigit()) {
            return this.getCategoriesTree();
        }
        let promise = this._treesForLang.get(lang);
        if (!promise) {
            const langParam = lang === YeshivaEnums.YeshivaModels.Logic.Globalization.Lang.En ? 'en' : 'he';
            promise = firstValueFrom(this._http.get<string>(this.categoryTreeUrl + '/tree?lang=' + langParam)).then((raw) => this._parseTreeResponse(raw));
            //failures are not memoized - the next caller retries
            promise.catch(() => this._treesForLang.delete(lang));
            this._treesForLang.set(lang, promise);
        }
        return promise;
    }

    /**
     * Re-fetches a language's full tree fresh (the nihul's picker refresh after the server-side
     * list clean), over the SAME url the normal load of that language uses - the server purges
     * exactly those urls, and a different form (a ?lang= on the app's own language) would be a
     * separate cached object the purge never reached. The app's own language reloads the SHARED
     * tree and id dictionary (what getCategoriesTree answers: the next form, the overlay, the
     * menus); the override language replaces its per-language memo. Resolves to the full tree.
     */
    reloadTreeForLang(lang: YeshivaEnums.YeshivaModels.Logic.Globalization.Lang): Promise<any> {
        if (lang === this._i18n.getLangDigit()) {
            return this.getTree().then(() => {
                this.createCategoriesDictonary();
                return this.categoriesFullTree;
            });
        }
        const langParam = lang === YeshivaEnums.YeshivaModels.Logic.Globalization.Lang.En ? 'en' : 'he';
        const promise = firstValueFrom(this._http.get<string>(this.categoryTreeUrl + '/tree?lang=' + langParam)).then((raw) => this._parseTreeResponse(raw));
        promise.catch(() => this._treesForLang.delete(lang));
        this._treesForLang.set(lang, promise);
        return promise;
    }

    getCategoriesSeriesTree(menuTree: boolean = false): Promise<any> {
        return this.loadSeriesTreeAndDictonery().then((loaded) => {
            if (!loaded) {
                // problem to get the tree
                return null;
            }

            if (menuTree && this._contentAreaService.area === YeshivaEnums.AngularApp.API.enums.Area.midrash) {
                return this.categoriesSeriesTree;
            } else {
                return this.categoriesSeriesFullTree;
            }
        });
    }
    public getRabbiCategoriesTree(ravId: number, menuTree: boolean = false, generalRabbi: boolean = true): Promise<CategoryNode> {
        return firstValueFrom(this._http.get<CategoryNode>(this.categoryUrl + `/RavCategories?rabbiId=${ravId}&generalRabbi=${generalRabbi}`));
    }
    /** Trees restricted to categories that have lessons of the given media types (MediaType flags,
     *  e.g. 6 = Video|Audio), keyed by the flags. Built by pruning a COPY of the regular tree
     *  against contentscategory/MediaCategories, so the filtered variant never touches the
     *  cached categoriesTree/categoriesFullTree the menus use. */
    private _mediaTreePromises = new Map<number, Promise<CategoryNode | null>>();
    public getCategoriesTreeWithMedia(mediaTypes: number): Promise<CategoryNode | null> {
        let treePromise = this._mediaTreePromises.get(mediaTypes);
        if (!treePromise) {
            treePromise = Promise.all([
                this.getCategoriesTree(),
                firstValueFrom(this._http.get<number[]>(this.categoryTreeUrl + '/MediaCategories?mediaTypes=' + mediaTypes)),
            ])
                .then(([fullTree, mediaCatIds]) => {
                    if (!fullTree) {
                        return null;
                    }
                    return this._pruneTreeToCategories(fullTree as CategoryNode, new Set(mediaCatIds ?? []));
                })
                .catch((error) => {
                    this._mediaTreePromises.delete(mediaTypes);
                    this.errorService.log(error);
                    return null;
                });
            this._mediaTreePromises.set(mediaTypes, treePromise);
        }
        return treePromise;
    }

    /** A copied tree keeping only nodes whose subtree (self included) intersects keepIds. */
    private _pruneTreeToCategories(node: CategoryNode, keepIds: Set<number>): CategoryNode | null {
        const children = (node.children ?? [])
            .map((child) => this._pruneTreeToCategories(child as CategoryNode, keepIds))
            .filter((child): child is CategoryNode => !!child);
        if (!keepIds.has(node.id) && children.length === 0) {
            return null;
        }
        return { ...node, children };
    }
    getCategoriesDictonery(): Promise<any> {
        return this.categoriesDataLoadedSubject
            .asObservable()
            .toPromise()
            .then((loaded) => {
                if (loaded) {
                    return this.categoriesHash;
                } else {
                    // problem to get the dictonary
                    return null;
                }
            });
    }
    getCategoriesSeriesDictonery(): Promise<any> {
        return this.loadSeriesTreeAndDictonery().then((loaded) => {
            if (loaded) {
                return this.categoriesSeriesHash;
            } else {
                // problem to get the dictonary
                return null;
            }
        });
    }
    waitForCategoriesDictoneryLoaded(): Promise<boolean> {
        let observe = this.categoriesDataLoadedSubject.asObservable();
        let waiter = new Promise<any>((resolve, reject) => {
            //wait for the load event
            this.subscribes.push(
                observe.subscribe((load) => {
                    //false = the tree load failed; answer at once instead of running out the timer
                    resolve(load);
                }),
            );

            //but return in up to 5 sec
            _globals.setTimeoutIsNotServer(() => {
                resolve(false);
            }, 5000);
        });

        return waiter;
    }
    waitForCategoriesSeriesDictoneryLoaded(): Promise<boolean> {
        let resolved = false;
        let waiter = new Promise<boolean>((resolve) => {
            this.loadSeriesTreeAndDictonery().then((loaded) => {
                if (!resolved) {
                    resolved = true;
                    resolve(loaded);
                }
            });

            //but return in up to 5 sec
            _globals.setTimeoutIsNotServer(() => {
                if (!resolved) {
                    resolved = true;
                    resolve(false);
                }
            }, 5000);
        });

        return waiter;
    }
    getCategoryfromDictionery(id: number): CategoryNode {
        return this.categoriesHash[id];
    }
    getSeriesCategoryfromDictionery(id: number): CategoryNode {
        return this.categoriesSeriesHash[id];
    }

    private loadTreeAndDictonery(): Promise<any> {
        this.categoriesDataLoadedSubject.next(false);
        return this.getTree()
            .then(() => {
                this.createCategoriesDictonary();
                this.categoriesDataLoadedSubject.next(true);
                this.categoriesDataLoadedSubject.complete();
            })
            .catch((error) => {
                //a failed tree read used to reject with no handler and leave the subject open, so
                //every awaiter (the breadcrumb, getCategory, the menus) hung silently and the
                //content page stopped half way through its entity handler. Report it and complete
                //with false: the tree consumers answer null/empty and the page goes on.
                this.errorService.log(error);
                this.categoriesDataLoadedSubject.next(false);
                this.categoriesDataLoadedSubject.complete();
            });
    }
    private loadSeriesTreeAndDictonery(): Promise<boolean> {
        if (this.categoriesSeriesLoadPromise) {
            return this.categoriesSeriesLoadPromise;
        }

        this.categoriesSeriesDataLoadedSubject.next(false);
        this.categoriesSeriesLoadPromise = this.getTree(true)
            .then(() => {
                this.createSeriesCategoriesDictonary();
                this.categoriesSeriesDataLoadedSubject.next(true);
                this.categoriesSeriesDataLoadedSubject.complete();
                return true;
            })
            .catch((error) => {
                this.categoriesSeriesLoadPromise = null;
                this.errorService.log(error);
                return false;
            });
        return this.categoriesSeriesLoadPromise;
    }
    // use those function only affter you make shure that tree and dictonary werer loaded correctly
    getTreeRoot(): any {
        return this.categoriesTree;
    }
    getSeriesTreeRoot(): any {
        return this.categoriesSeriesTree;
    }
    private _getIsMainCategory(catId: number): boolean {
        const mainCategories = this.getTreeRoot().children;
        return mainCategories && mainCategories.filter((child: CategoryNode) => child.id === catId).length > 0;
    }

    getCategoryName(id: number): string {
        return this.getCategoryfromDictionery(id).name;
    }
    getSeriesCategoryName(id: number): string {
        return this.getSeriesCategoryfromDictionery(id).name;
    }
    getCategoryParent(id: number): CategoryNode | null {
        let parent: CategoryNode | null = null;
        try {
            parent = this.getCategoryfromDictionery(id).parent ?? null;
            if (!parent) {
                //id == 3
                return null;
            }
            if (parent.id === this.getTreeRoot().id) {
                return null;
            }
        } catch (error) {}

        return parent;
    }
    getSeriesCategoryParent(id: number): CategoryNode | null {
        let parent: CategoryNode | null = null;
        try {
            parent = this.getSeriesCategoryfromDictionery(id).parent ?? null;
            if (!parent) {
                //id == 3
                return null;
            }
            if (parent.id === this.getSeriesTreeRoot().id) {
                return null;
            }
        } catch (error) {}

        return parent;
    }
    getCategoryChildren(id: number): CategoryNode[] {
        try {
            return this.getCategoryfromDictionery(id).children;
        } catch (error) {
            return [];
        }
    }
    getSeriesCategoryChildren(id: number): CategoryNode[] {
        try {
            return this.getSeriesCategoryfromDictionery(id).children;
        } catch (error) {
            return [];
        }
    }
    getRootCategoryLink() {
        let rootId = 3;
        try {
            rootId = this.getTreeRoot().id;
        } catch (error) {}

        return _globals.categoryLink(rootId);
    }

    ngOnDestroy(): void {
        if (this._categoryWrapper$) {
            this._categoryWrapper$.unsubscribe();
        }
        if (this._isCategoryTreeMenuOpen$) {
            this._isCategoryTreeMenuOpen$.unsubscribe();
        }
        if (this.categoriesDataLoadedSubject) {
            this.categoriesDataLoadedSubject.unsubscribe();
        }
        if (this.categoriesSeriesDataLoadedSubject) {
            this.categoriesSeriesDataLoadedSubject.unsubscribe();
        }
        this._utils.unsubscribe(this.subscribes);
    }
}

export class CategoryNode implements YeshivaModels.BE.CategoryTree {
    children!: YeshivaModels.BE.CategoryTree[];
    childrenIdsAll!: number[];
    id!: number;
    isSeries!: boolean;
    name!: string;
    nameWords?: string[];
    priority!: number;
    hideInTree!: boolean;
    public parent?: CategoryNode;
}
